<template>
  <div class="form-item">
    <div class="form-item-label">
      {{ label }}<i v-if="required" class="required">*</i>
    </div>
    <slot></slot>
  </div>
</template>
  <script>
export default {
  name: 'form-item',
  props: {
    label: String,
    required: {
      type: Boolean,
      default: true,
    },
  },
}
</script>
  <style lang="less">
.form-item {
  margin-bottom: 30px;
  .form-item-label {
    font-size: 15px;
    color: #646464;
    margin-bottom: 6px;
    .required {
      color: #cb0202;
    }
  }
}
@media (min-width: 768px) {
  .form-item {
    margin-bottom: 40px;
    .form-item-label {
      margin-bottom: 10px;
      font-size: 22px;
    }
  }
}
</style>